<div class="mb-2 px-4" [ngClass]="field.fieldSize? 'col-md-' + field.fieldSize : field.label.length > 100 ?
  'col-md-12': field.label.length > 50 ?
  'col-md-6' :  field.label.length > 30 ?
  'col-md-4' :'col-md-3'" [formGroup]="group" style="display: inline-block;top: 10px;" [matTooltip]="field.hint"
  [matTooltipDisabled]="!field.hint" matTooltipPosition="above" matTooltipClass="sbm-tooltip">

  <label>
    <app-required *ngIf="isRequired()"></app-required>
    <ng-container *ngIf="field.sequence>=0 && !field.hideSequence"> {{field.sequence + 1}}) </ng-container>
    {{field.label}}
  </label><br />

  <mat-radio-group [formControlName]="field.name">
    <mat-radio-button *ngFor="let item of field.fieldOptions" [value]="item" color="primary">{{item}}</mat-radio-button>
  </mat-radio-group>

  <ng-container *ngFor="let validation of field.validations;" ngProjectAs="mat-error">
    <mat-error *ngIf="group.get(field.name).touched && group.get(field.name).hasError(validation.name)">
      {{validation.message ? validation.message : getValidationMessage(validation.name)}}
    </mat-error>
  </ng-container>

</div>
